import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import React from 'react';

import LoadingPlaceholder from 'presentation/components/icons/LoadingPlaceholder';
import styles from 'presentation/components/styles/ConnectionErrorBanner.css';
import TryAgain from 'presentation/components/icons/TryAgain';

class ConnectionErrorBanner extends React.Component {
  constructor(props) {
    super(props);

    ConnectionErrorBanner.propTypes = {
      isChatClientConnected: PropTypes.bool.isRequired,
      isChatClientReconnecting: PropTypes.bool.isRequired,
      onClick: PropTypes.func.isRequired,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleClick() {
    this.props.onClick();
  }

  handleKeyDown(ev) {
    if (ev.keyCode === 13 || ev.keyCode === 32) {
      ev.preventDefault();
      this.handleClick();
    }
  }

  render() {
    return (
      <div className={styles.connectionErrorBannerWrapper}>
        <CSSTransition
          classNames={{
            enter: styles.connectionErrorBannerTransitionEnter,
            enterDone: styles.connectionErrorBannerTransitionEnterDone,
            exit: styles.connectionErrorBannerTransitionExit,
            exitDone: styles.connectionErrorBannerTransitionExitDone,
            exitActive: styles.connectionErrorBannerTransitionExitActive,
          }}
          in={!this.props.isChatClientConnected}
          timeout={300}
          unmountOnExit
        >
          <div
            className={styles.connectionErrorBanner}
            tabIndex="0"
            role="button"
            onClick={this.handleClick}
            onKeyDown={this.handleKeyDown}
          >
            <div className={styles.connectionErrorMessage}>Uh oh - we can't connect!</div>
            <div className={styles.connectionErrorTryAgainWrapper}>
              {this.props.isChatClientReconnecting ? (
                <LoadingPlaceholder isErrorBanner color="#FFFFFF" size="10px" />
              ) : (
                <TryAgain />
              )}
            </div>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default ConnectionErrorBanner;
